/**
 * English-only count formatter: "1 term", "2 terms". Prefer
 * {@link pluralizeTemplate} with server-provided forms for user-visible copy;
 * this remains for English-default fallbacks.
 */
export function pluralize(count, singular, plural) {
  return `${count} ${count === 1 ? singular : plural || singular + "s"}`;
}

/**
 * Pick the `.one` form when count === 1, `.other` otherwise, and substitute the
 * literal %{count} placeholder. Forms come from server-provided label JSON
 * (Rails-style pluralization templates), e.g.
 * `pluralizeTemplate({ one: "%{count} term entered", other: "%{count} terms entered" }, 2)`.
 *
 * @param {{one: string, other: string}} forms
 * @param {number} count
 * @returns {string}
 */
export function pluralizeTemplate(forms, count) {
  const template = count === 1 ? forms?.one : forms?.other;

  return String(template ?? "").replaceAll("%{count}", count);
}
